import { ActionTypes } from '../actions';

const initialState = {};

export default function mobileToken(state = initialState, action) {
  switch (action.type) {
  case ActionTypes.MobileTokenTypes.SET_TOKEN:
    return {
      ...state,
      token: action.token,
    };
  case ActionTypes.MobileTokenTypes.SET_MESSAGE:
    return {
      ...state,
      message: action.message,
    };
  case ActionTypes.MobileTokenTypes.SET_MOBILE_VERSION:
    return {
      ...state,
      mobileVersion: action.mobileVersion,
    };
  case ActionTypes.MobileTokenTypes.SET_MOBILE2_URL:
    return {
      ...state,
      mobile2url: action.mobile2url,
    };
  default:
    return state;
  }
}
